import { io } from "socket.io-client";

const ENDPOINT = process.env.REACT_APP_base_URL;

const socket = io(ENDPOINT, { autoConnect: false }); // Don't connect automatically

export default socket;